import React, { useEffect, useRef, useState } from 'react';
import {I_IQPlayerGallery, I_IQPlayerGalleryWrapper} from "./interfaces";
import Gallery from "../gallery/gallery";
import IQPS_Images from "./components/iqps-images";
import {isMobile} from "../../../domain/common";
import IQPS_Audio, { STOP_PLAY_OTHER_EVENT } from "./components/iqps-audio";




interface I_IQPlayerSliderProps {
    elId: number;
    iQPlayerGalleryWrapper: I_IQPlayerGalleryWrapper;
}

const IQPlayerSliderApp: React.FC<I_IQPlayerSliderProps> = ( props: I_IQPlayerSliderProps ) => {

    //console.log('IQPlayerSliderApp',props?.iQPlayerGalleryWrapper.iQPlayerGallery);
    /*STOP PLAY OTHER EVENT*/
    useEffect(() => {
        const handleStopOther = () => {
           console.log('STOP_PLAY_OTHER_EVENT');
        };

        document.addEventListener(STOP_PLAY_OTHER_EVENT, handleStopOther);

        return () => document.removeEventListener(STOP_PLAY_OTHER_EVENT, handleStopOther);
    }, []);



    return (
        <div className="iq-player-wrapper text-white">
            {/*<div>*/}
            {/*    iQPlayerGallerySettings.type: {props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.type}*/}
            {/*</div>*/}

            <div>
                <Gallery
                    adaHideNonVisibleSlides={ true }
                    galleryStaticContentClasses=""
                    galleryStaticContentArrowClasses="mb-0"
                    allowVerticalScrolling={ true }
                    isArrowsOverflow={true}

                    //for lg size set desktopItemsPerSlide to 3
                    desktopItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_d }
                    tableItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_t }
                    mobileItemsPerSlide={ props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.itemsPerSlide_m }
                    codeName="cp"
                    items={ props?.iQPlayerGalleryWrapper.iQPlayerGallery }
                    loop={ true }
                    classes="w-full"
                    gap={ isMobile() ? 4 : 1 }
                    // style={{ paddingRight:"0px", paddingLeft:"0px", marginRight:"0px", marginLeft:"0px" }}
                    duration={ 1500 }
                    arrowsColor="white"
                    renderItem={(item: I_IQPlayerGallery) => {
                        return (
                           <div className="px-1 py-2 md:px-4 md:py-6 transition-transform duration-150 hover:scale-105" key={'i' + item.runID}>
                               {props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.type === 'audio' &&
                                   <IQPS_Audio
                                       runID={item.runID}
                                       iQPlayerGallerySettings={props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings}
                                       item={item} />}

                               {props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings.type === 'images' &&
                                   <IQPS_Images iQPlayerGallerySettings={props?.iQPlayerGalleryWrapper.iQPlayerGallerySettings} item={item} />}
                           </div>
                        )
                    }}
                />
            </div>
        </div>
    );
};

export default IQPlayerSliderApp;